// extracted by mini-css-extract-plugin
export default {"tileMenu":"sidebar_tileMenu__POtla","sider":"sidebar_sider__qkqTJ"};